import React, { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import { verifyToken } from "./lib/api";

function Protected({ children }) {
  const [status, setStatus] = useState("checking");
  useEffect(() => {
    verifyToken().then((ok) => setStatus(ok ? "ok" : "fail"));
  }, []);
  if (status === "checking") {
    return (
      <div className="min-h-screen grid place-items-center bg-[#0A0A0A] text-gray-500 font-mono text-xs uppercase tracking-[0.2em]">
        Yetki doğrulanıyor...
      </div>
    );
  }
  if (status === "fail") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          style: {
            background: "#0F0F10",
            border: "1px solid #27272A",
            color: "#F9FAFB",
            fontFamily: "JetBrains Mono, monospace",
            fontSize: 12,
            borderRadius: 2,
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <Protected>
                <Dashboard />
              </Protected>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
